import { IIconProps, DEFAULT_ICON_PROPS } from './constants';

export const ChevronUpIcon = ({ ariaLabel = 'Chevron up', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className, strokeWidth } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <path
        d="M18 15L12 9L6 15"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
